export default __webpack_public_path__ + "static/media/returns-active.c58a5e87.svg";